import { render, staticRenderFns } from "./EmailPreview.vue?vue&type=template&id=534734a5&scoped=true&"
import script from "./EmailPreview.vue?vue&type=script&lang=js&"
export * from "./EmailPreview.vue?vue&type=script&lang=js&"
import style0 from "./EmailPreview.vue?vue&type=style&index=0&id=534734a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534734a5",
  null
  
)

export default component.exports